import React from "react";
import { EvaluationCard, EvaluationFooter } from "./components";
import EvaluationSlider from "../../../Components/Student/EvaluationSlider";
import { FLUENCY_LEVELS } from "./constants";

const FluencyStep = ({
  fluencyScore,
  setFluencyScore,
  fluencyNotes,
  setFluencyNotes,
  onBack,
  onNext,
  isSaving,
}) => {
  return (
    <div
      className="mx-auto"
      style={{
        maxWidth: "860px",
        width: "100%",
        direction: "rtl",
        paddingBottom: "100px",
      }}
    >
      <EvaluationCard className="mb-4">
        <h4
          className="text-center mb-1 fw-bold text-dark"
          style={{ fontSize: "22px" }}
        >
          تقييم طلاقة القراءة
        </h4>
        <div
          className="text-muted text-center mb-4"
          style={{ fontSize: "14px" }}
        >
          قيم طلاقة الطالب بناءً على مستوى الأداء:
        </div>

        <EvaluationSlider
          score={fluencyScore}
          feedback={fluencyNotes}
          isEditable={true}
          onScoreChange={setFluencyScore}
          onFeedbackChange={setFluencyNotes}
          levels={FLUENCY_LEVELS}
          title="تقييم المعلم (درجة)"
          showDescriptionOnly={true}
        />
      </EvaluationCard>

      <EvaluationFooter
        primaryText="الاستمرار"
        secondaryText="الرجوع"
        onPrimaryClick={onNext}
        onSecondaryClick={onBack}
        showSecondary={true}
        isSaving={isSaving}
      />
    </div>
  );
};

export default FluencyStep;
